"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var View = function View(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.872 15.848c-3.584 0-6.832-2.152-8.324-5.536-.076-.176-.096-.44-.004-.604l.424-.768c1.556-2.824 4.428-4.652 7.504-4.776l.136-.004c3.688-.152 7.056 2.064 8.584 5.532l.028.064a.61.61 0 01-.024.54l-.424.768c-1.556 2.824-4.432 4.652-7.504 4.776l-.136.004c-.088.004-.176.004-.26.004zm-7.104-5.82c1.404 2.912 4.248 4.696 7.328 4.592l.116-.004c2.652-.104 5.136-1.692 6.484-4.14l.276-.5c-1.368-2.884-4.224-4.664-7.332-4.592l-.116.004c-2.652.108-5.136 1.692-6.484 4.14l-.272.5zM17.58 9.96l.004.004.044-.024-.048.02z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.867 12.568a2.847 2.847 0 01-2.844-2.844A2.847 2.847 0 019.867 6.88a2.847 2.847 0 012.844 2.844 2.847 2.847 0 01-2.844 2.844zm0-4.46a1.617 1.617 0 10.002 3.233 1.617 1.617 0 00-.002-3.233z",
    fill: color
  }));
};
var _default = exports["default"] = View;